module.exports = __webpack_public_path__ + "img/lens-174-plus-05.0f4a7111.png";